import React, { useEffect, useRef, useState } from "react";
import Slider from 'react-slick';
import CSSetupImage from "../../images/Setup.png";
import CSSetupImage1 from "../../images/Setup-2.png";
import IconDataManagement from "../../icons/icon-data-management-cs.svg";
import IconSalesCollaboration from "../../icons/icon-sales-collaboration.svg";
import IconSmartEmail from "../../icons/icon-smart-emails.svg";
import IconBuiltInCalling from "../../icons/icon-built-in-calling.svg";
import IconEmailCalendar from "../../icons/icon-email-calendar-sync.svg";
import IconEnterpriseSecurity from "../../icons/icon-enterprise-security.svg";
import IconRealTimeNotifications from "../../icons/icon-real-time-notifications.svg";
import IconSalesIntelligence from "../../icons/icon-sales-intelligence.svg";
import IconTextCampaigns from "../../icons/icon-text-campaigns.svg";
import Parallax from "../common/utils/animations/parallax";
import SlideOnScroll from "../common/utils/animations/slideOnScroll";
import { directions } from "../common/utils/animations/animationConstants";

const sliderItems = [
  {
    icon: <IconEmailCalendar />,
    title: "Email & Calendar Sync",
    content: "Sync and auto link your email inbox and calendars"
  }, {
    icon: <IconBuiltInCalling />,
    title: "Built-in Calling",
    content: "Make and record calls, drop voicemails, and coach your reps"
  }, {
    icon: <IconSmartEmail />,
    title: "Smart Emails",
    content: "Send and track personalized emails, get reminders, and deeper insights"
  }, {
    icon: <IconTextCampaigns />,
    title: "Text Campaigns",
    content: "Create text templates, run bulk text campaigns or send personal texts"
  }, {
    icon: <IconSalesCollaboration />,
    title: "Sales Collaboration",
    content: "Work with your entire team - use mentions, assign deals and tasks"
  }, {
    icon: <IconRealTimeNotifications />,
    title: "Real-time Notifications",
    content: "Get real-time notifications for all events, rep, and contact activities"
  }, {
    icon: <IconSalesIntelligence />,
    title: "Sales Intelligence",
    content: "Use built-in or create custom reports and dashboards, and share them"
  }, {
    icon: <IconEnterpriseSecurity />,
    title: "Enterprise Security",
    content: "Powerful security with access control, encryption, GDPR  and audit trails"
  }, {
    icon: <IconDataManagement />,
    title: "Data Management",
    content: "Import, export, bulk update data with a complete lineage"
  },
];
export default function SalesmateCSOurProduct() {
  const [isMobile, setisMobile] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const setValues = () => {
      setisMobile(window.innerWidth <= 767);
    };
    setValues();
    window.addEventListener('resize', () => {
      setValues();
    });
    return () => {
      window.removeEventListener('resize', () => {
        setValues();
      });
    };
  });

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 5000,
    autoplay: true,
    fade: true,
    speed: 1000,
    cssEase: 'linear'
  };

  const settings1 = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  const triggerPoints = [[0.9, 0.8], [0.85, 0.75], [0.8, 0.7], [0.9, 0.8], [0.85, 0.75], [0.8, 0.7], [0.9, 0.8], [0.85, 0.75], [0.8, 0.7],];
  return (
    <div className="cs-ourproduct-section section-gap sm-ourproduct-section">
      <div ref={ref} className="ourproduct-top-section section-gap">
        <div className="container">
          <div className="row d-flex flex-wrap align-start">
            <div className="col cs-ourProduct-content">
              <h2 className="h3">Flex to fit any sales process</h2>
              <p>The feature set was vast and extremely complex. First, we needed to build a robust yet highly flexible foundation that will allow customers to customize Salesmate to fit their unique sales process. There were more than 200+ configurable features such as custom modules, custom fields, security roles and permission, sales pipelines, custom reports and dashboards, smart views, time zones. </p>

              <p>We designed the technology, architecture, databases, and APIs that allowed us to deliver the MVP in 12 weeks without compromising flexibility and extendability.</p>
            </div>
            <Parallax classes="col cs-ourProduct-image" triggers={[1.1, 0.3]} id="cs-ourProduct-image">
              <Slider {...settings}>
                <img src={CSSetupImage} className="cb-setup" title="Best crm features" alt="crm features" />
                <img src={CSSetupImage1} className="cb-setup" title="Best crm features" alt="crm features" />
              </Slider>
            </Parallax>
          </div>
        </div>
      </div>

      <div className="ourproduct-bottom-section">
        <div className="container section-gap">
          <div className="ourproduct-bottom-content">
            <h2 className="h3">Save-time, Sell more, Close deals</h2>
            <p>We spent days understanding our target customers, their routines and core challenges to meticulously and thoughtfully design each power tool that ultimately radicalized the way sales reps were spending their time. With these tools, they were able to connect with more prospects, add a personal touch to their sales, and multiply their sales in a matter of months. These tools delivered powerful automation at each stage of the sales lifecycle:</p>
          </div>

        </div>

        <div className="grid-layout-section-style-2">
          <div className="container">
            {isMobile && <div className="row d-flex flex-wrap">
              <Slider {...settings1}>
                {sliderItems.map((item, i) => {
                  return <div className="col grid-item-style-2" key={i}>
                    <div className="item-inner">
                      <div className="grid-icon-left">
                        <i className="icon-small">{item.icon}</i>
                      </div>
                      <h3>{item.title}</h3>
                      <p>{item.content}</p>
                    </div>
                  </div>;
                })}
              </Slider>
            </div>}
            {!isMobile && <>
              <div className="row d-flex flex-wrap" >
                {sliderItems.map((item, i) => {
                  return <Parallax id={"grid-item-style-2-" + i} triggers={triggerPoints[i]} classes="col grid-item-style-2" key={i} direction={directions.BTT} length={50} opacity={true}>
                    <div className="item-inner">
                      <div className="grid-icon-left">
                        <i className="icon-small">{item.icon}</i>
                      </div>
                      <h3>{item.title}</h3>
                      <p>{item.content}</p>
                    </div>
                  </Parallax>;
                })}

              </div>
            </>}
          </div>
        </div>
      </div>
    </div>
  );
}
